import type { FC } from 'react'
import { useMemo } from 'react'
import { cn } from '@/utils'
import type { Cue, CueType } from '@rundown-studio/types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash, faForward } from '@fortawesome/free-solid-svg-icons'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '../../components/interactives/Tooltip'
import { getCueTooltipText } from './lib/get-hidden-cue-tooltip-text'

type CueHiddenIndicatorProps = {
  cueType: CueType
  cueSettings: Cue['settings']
  className?: string
  skipDuringShow: boolean
}

export const CueStateIndicator: FC<CueHiddenIndicatorProps> = ({
  cueType,
  cueSettings,
  className,
  skipDuringShow,
}) => {
  const { hideOnCsv, hideOnPdf } = cueSettings ?? {}

  const isHidden = hideOnCsv || hideOnPdf
  const hasIndicator = isHidden || skipDuringShow

  const tooltipContent = useMemo(
    () => getCueTooltipText(cueType, { hideOnPdf, hideOnCsv, skipDuringShow }),
    [cueType, hideOnCsv, hideOnPdf, skipDuringShow],
  )

  if (!hasIndicator) return null

  return (
    <div className={cn('flex items-center justify-center gap-1 z-20', className)}>
      <Tooltip>
        <TooltipTrigger>
          <div className="flex items-center gap-1 cursor-help">
            {skipDuringShow && (
              <FontAwesomeIcon icon={faForward} size="xs" className="opacity-50" />
            )}
            {isHidden && (
              <FontAwesomeIcon icon={faEyeSlash} size="xs" className="opacity-50" />
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>{tooltipContent}</TooltipContent>
      </Tooltip>
    </div>
  )
}
